// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1m48f","legacyBtn":"MutateMid_legacyBtn__3xxwX"};